import {
  requestDeleteDegree,
  requestGetDegree,
  requestPostCreateDegree,
  requestUpdateDegree,
} from 'app/api/degree'
import {
  IParamsGetDegree,
  IPayloadCreateDegree,
  IPayloadUpdateDegree,
  IResponseDegreeList,
  IDegree,
} from 'app/api/degree/model'
import { getToken } from 'app/service/storage/storage-service'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { IResponseQueryList } from '../model/common'
import { DegreeKeys } from '../query-key/degree'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function useGetDegreeList(params: IParamsGetDegree, enabled = true) {
  const token = getToken()
  return useQuery<IResponseQueryList<IDegree[]>, undefined>(
    DegreeKeys.listDegree(params),
    async () => {
      try {
        const res: IResponseDegreeList = await requestGetDegree(params)
        const data: IDegree[] = res?.data?.rows || []
        return {
          data,
          total: res?.data?.total ?? 0,
        }
      } catch (error: any) {
        return {
          data: [],
          total: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}

export const useDeleteDegree = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, number[], unknown>(
    async (body: number[]) => {
      await requestDeleteDegree(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: DegreeKeys.allDegrees,
        })
      },
    },
  )
}

export const useUpdateDegree = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadUpdateDegree, unknown>(
    async (body: IPayloadUpdateDegree) => {
      await requestUpdateDegree(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: DegreeKeys.allDegrees,
        })
      },
    },
  )
}

export const useCreateDegree = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadCreateDegree, unknown>(
    async (body: IPayloadCreateDegree) => {
      await requestPostCreateDegree(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: DegreeKeys.allDegrees,
        })
      },
    },
  )
}
